module.exports = __webpack_public_path__ + "img/女-乳腺癌h.c7612c0a.png";